// src/landing/PublicPages.jsx
// ─── Pages publiques hors landing (§21, §40, §50-52) ────────────────────────
// Chaque page rend son contenu et rien d'autre : PublicSiteShell fournit
// navbar et footer. Aucune n'importe LandingV2 ni un hero marketing.

import DemoLeadForm from "./DemoLeadForm";
import PricingGrid from "./PricingGrid";
import { useEffect, useState, useRef } from "react";
import { ARTICLES, publishedArticles, categoryLabel } from "./blog-catalog";
import { PRICING_PLANS } from "../config/pricing";

export function DemoLeadPage({ apiUrl, onPrivacy, nav }) {
  return (
    <main className="lv2-demo-page">
      <div className="lv2-wrap lv2-demo-page-inner">
        <div className="lv2-eyebrow lv2-center">VehicleIQ</div>
        <h1>Un assistant IA pour les dirigeants VO.</h1>
        <p className="lv2-lead">7 jours gratuits, sans engagement. Découvrez comment VIQ.AI centralise vos flux d’information, structure votre workflow et vous aide à piloter sourcing, mails, agenda, prospects et objectifs depuis un même environnement.</p>
        <DemoLeadForm apiUrl={apiUrl} onPrivacy={onPrivacy} onDiscover={() => nav("/")} variant="demo_page" />
      </div>
    </main>
  );
}

const PRICING_FAQ = [
  ["Que comprend l'essai gratuit ?", "Les capacités essentielles de VIQ.AI pendant 7 jours, sans carte bancaire, avec jusqu’à 4 opportunités structurées dans le Scan VIQ.AI. Essential, Pro et Team lèvent cette limite produit."],
  ["Puis-je changer de forfait ?", "Oui, à tout moment. Le passage d'Essential à Pro est immédiat ; le retour se fait à l'échéance en cours."],
  ["Y a-t-il un engagement ?", "Les abonnements mensuels sont résiliables à tout moment et restent actifs jusqu'à la fin du mois payé. L'annuel est facturé en une fois pour douze mois ; sa résiliation coupe le renouvellement à l'échéance."],
  ["Combien d'utilisateurs dans VIQ.AI Pro ?", "Trois utilisateurs inclus, avec mémoire partagée et permissions. Au-delà, VIQ.AI Team."],
  ["Comment la TVA est-elle traitée ?", "Tant que VehicleIQ bénéficie de la franchise en base de TVA (art. 293 B du CGI), la TVA n'est pas facturée : le montant affiché lors de la souscription est le montant VehicleIQ à payer."],
];

export function PricingPage({ onSelectPlan, onQuote, apiUrl = "", refCode = null }) {
  return (
    <main className="lv2-section">
      <div className="lv2-wrap lv2-center">
        <div className="lv2-eyebrow">Tarification</div>
        <h1 className="lv2-h2" style={{ fontSize: "clamp(2rem,4vw,2.8rem)" }}>Quatre moteurs IA. Un seul abonnement. Plus de temps pour piloter.</h1>
        <p className="lv2-lead">Claude, ChatGPT, Mistral et Gemini sont synchronisés dans VIQ.AI pour centraliser vos informations, réduire les tâches répétitives et fiabiliser vos décisions. Choisissez simplement le niveau d’usage et de collaboration adapté à votre organisation.</p>
        <PricingGrid onSelect={onSelectPlan} onQuote={onQuote} detailed apiUrl={apiUrl} refCode={refCode} />

        <h2 className="lv2-h2" style={{ fontSize: "1.5rem", marginTop: "4rem" }}>Comparatif</h2>
        <div className="lv2-art-table-wrap" style={{ maxWidth: 1180, margin: "1.5rem auto 0" }}>
          <table className="lv2-art-table">
            <thead><tr><th>Capacité</th>{["trial", "essential", "pro", "team"].map(k => <th key={k}>{PRICING_PLANS[k].label.replace("VIQ.AI ", "")}</th>)}</tr></thead>
            <tbody>
              {[
                ["4 moteurs IA dans un seul abonnement", "Claude · ChatGPT · Mistral · Gemini", "Claude · ChatGPT · Mistral · Gemini", "Claude · ChatGPT · Mistral · Gemini", "Claude · ChatGPT · Mistral · Gemini"],
                ["Contexte métier unifié", "Mails · agenda · sourcing · prospects · dossiers", "Mails · agenda · sourcing · prospects · dossiers", "Mails · agenda · sourcing · prospects · dossiers", "Contexte partagé organisation"],
                ["Workflow & priorités", "Suggestions VIQ.AI", "Pilotage individuel", "Pilotage partagé", "Pilotage multi-équipe"],
                ["Sourcing relié aux objectifs", "30+ marketplaces & enchères · 7 pays", "30+ marketplaces & enchères · 7 pays", "30+ marketplaces & enchères · 7 pays", "30+ marketplaces & enchères · 7 pays"],
                ["Pays couverts", "🇫🇷 🇩🇪 🇧🇪 🇳🇱 🇪🇸 🇮🇹 🇵🇱", "🇫🇷 🇩🇪 🇧🇪 🇳🇱 🇪🇸 🇮🇹 🇵🇱", "🇫🇷 🇩🇪 🇧🇪 🇳🇱 🇪🇸 🇮🇹 🇵🇱", "🇫🇷 🇩🇪 🇧🇪 🇳🇱 🇪🇸 🇮🇹 🇵🇱"],
                ["Profils sourcing actifs", "Jusqu’à 10", "Jusqu’à 10", "Jusqu’à 10", "Jusqu’à 10"],
                ["Demandes d’achat clients", "Regroupement + file d’attente", "Regroupement + file d’attente", "Regroupement + file d’attente", "Regroupement + file d’attente"],
                ["Matching sourcing multi-critères", "Marque · modèle · année · énergie · pays · budget · km · options", "Marque · modèle · année · énergie · pays · budget · km · options", "Marque · modèle · année · énergie · pays · budget · km · options", "Marque · modèle · année · énergie · pays · budget · km · options"],
                ["Liens sourcing", "Annonces / recherches natives plateformes", "Annonces / recherches natives plateformes", "Annonces / recherches natives plateformes", "Annonces / recherches natives plateformes"],
                ["Opportunités structurées", "4 max pendant l’essai", "Illimité", "Illimité", "Illimité"],
                ["Assistant VIQ.AI", 1,1,1,1],
                ["Analyse photo & documents", 1,1,1,1],
                ["Identification plaque / VIN", 1,1,1,1],
                ["HistoVec enrichi · CarVertical", 1,1,1,1],
                ["Intelligence marché", 1,1,1,1],
                ["Dossiers VIQ", 1,1,1,1],
                ["Flux mails · agenda · CRM · workflow", 1,1,1,1],
                ["Mémoire véhicule", 1,1,1,1],
                ["Intégrations ciblées", "9 : Gmail · Calendar · Contacts · Sheets · YouTube · Outlook · WhatsApp · CarVertical · Webhooks", "9 : Gmail · Calendar · Contacts · Sheets · YouTube · Outlook · WhatsApp · CarVertical · Webhooks", "9 : Gmail · Calendar · Contacts · Sheets · YouTube · Outlook · WhatsApp · CarVertical · Webhooks", "9 : Gmail · Calendar · Contacts · Sheets · YouTube · Outlook · WhatsApp · CarVertical · Webhooks"],
                ["Réseau VehicleIQ", 1,1,1,1],
                ["Usage VIQ.AI", "7 jours", "Sans plafond mensuel", "Sans plafond mensuel", "Selon déploiement"],
                ["Cotes simultanées", "—", "3", "10", "Base Pro / devis"],
                ["Recommandations d’achat / requête", "—", "Jusqu’à 8", "Jusqu’à 12", "Base Pro / devis"],
                ["Utilisateurs inclus", "1 · 7 jours", "1", "3", "4 à 15"],
                ["Mémoire partagée équipe", 0,0,1,1],
                ["CRM & workflow partagés", 0,0,1,1],
                ["Permissions par utilisateur", 0,0,1,1],
                ["Notes · workflow · agenda synchronisés", 0,0,0,1],
                ["Mémoire d’entreprise & espace collaboratif", 0,0,0,1],
                ["Priorité de traitement", 0,0,1,1],
                ["Support prioritaire sous 24 h", 0,0,1,1],
                ["Accompagnement au déploiement", 0,0,0,1],
                ["Formations VIQ.AI", "—", "21 h / 3 j ou 14 h / 2 j · en ligne ou présentiel", "21 h / 3 j ou 14 h / 2 j · en ligne ou présentiel", "21 h / 3 j ou 14 h / 2 j · en ligne ou présentiel"],
                ["Engagement", "Sans carte bancaire", "Mensuel résiliable · annuel 12 mois", "Mensuel résiliable · annuel 12 mois", "Sur devis"]
              ].map(r => (
                <tr key={r[0]}><td>{r[0]}</td>{r.slice(1).map((c, i) => <td key={i}>{c === 1 ? "✓" : c === 0 ? "—" : c}</td>)}</tr>
              ))}
            </tbody>
          </table>
        </div>

        <h2 className="lv2-h2" style={{ fontSize: "1.5rem", marginTop: "4rem" }}>Questions sur les offres</h2>
        <div className="lv2-faq">{PRICING_FAQ.map(([q, a]) => <details key={q}><summary>{q}</summary><p>{a}</p></details>)}</div>
      </div>
    </main>
  );
}

export function BlogIndex({ nav }) {
  const published = publishedArticles();
  return (
    <main className="lv2-wrap lv2-section" style={{ paddingTop: "3rem" }}>
      <div className="lv2-eyebrow">Blog</div>
      <h1 className="lv2-h2" style={{ fontSize: "clamp(2rem,4vw,2.8rem)" }}>Articles</h1>
      <div className="lv2-articles">
        {published.map(a => (
          <button key={a.slug} className="lv2-card lv2-article" onClick={() => nav(`/blog/${a.slug}`)}>
            <div className="cat">{categoryLabel(a.category)} · {a.readingMin} min</div><h3>{a.title}</h3><p>{a.excerpt}</p>
          </button>
        ))}
        {!published.length && <p className="lv2-lead">Premiers articles en préparation.</p>}
      </div>
      <button className="lv2-btn secondary md" style={{ marginTop: "1.6rem" }} onClick={() => nav("/ressources")}>Voir les ressources par thème</button>
    </main>
  );
}

export function ApiPage({ onContact }) {
  return (
    <main className="lv2-wrap lv2-section" style={{ paddingTop: "3rem", maxWidth: 760 }}>
      <div className="lv2-eyebrow">API</div>
      <h1 className="lv2-h2" style={{ fontSize: "clamp(2rem,4vw,2.8rem)" }}>Intégrer VIQ.AI à vos outils.</h1>
      <p className="lv2-lead">L'API VehicleIQ expose l'identification véhicule, l'analyse de dossiers et le réseau à vos propres systèmes. Accès sur demande pour les comptes VIQ.AI Team et les intégrateurs.</p>
      <button className="lv2-btn primary md" style={{ marginTop: "1.6rem" }} onClick={onContact}>Demander un accès</button>
    </main>
  );
}

// ─── Pages légales dédiées (§58-61) ────────────────────────────────────────
// Vraies routes publiques, pas des modales : indexables, partageables,
// imprimables. La modale LegalModal reste pour l'espace user authentifié.
const LEGAL_META = {
  legal:            { title: "Mentions légales — VehicleIQ", h1: "Mentions légales", desc: "Mentions légales de VehicleIQ, édité par MKL Ingénierie et Conseil.", type: "mentions" },
  confidentialite:  { title: "Politique de confidentialité — VehicleIQ", h1: "Politique de confidentialité", desc: "Traitement des données personnelles par VehicleIQ : finalités, bases légales, durées de conservation et exercice des droits.", type: "privacy" },
  cgu:              { title: "Conditions générales d'utilisation — VehicleIQ", h1: "Conditions générales d'utilisation", desc: "Conditions d'utilisation de la plateforme VehicleIQ et de l'assistant VIQ.AI.", type: "cgu" },
  cgv:              { title: "Conditions générales de vente — VehicleIQ", h1: "Conditions générales de vente", desc: "Conditions de souscription aux forfaits VIQ.AI : tarifs, essai, résiliation, responsabilité.", type: "cgv" },
};

export function LegalPage({ page, LegalContent, version, date, nav, onLogin, onTry }) {
  const meta = LEGAL_META[page] || LEGAL_META.legal;
  const displayVersion = page === "confidentialite" ? "2.3" : version;
  const displayDate = page === "confidentialite" ? "2026-09-11" : date;
  const bodyRef = useRef(null);
  const [toc, setToc] = useState([]);
  const [activeId, setActiveId] = useState(null);

  useEffect(() => {
    if (typeof document === "undefined") return;
    document.title = meta.title;
    let d = document.querySelector('meta[name="description"]');
    if (!d) { d = document.createElement("meta"); d.setAttribute("name", "description"); document.head.appendChild(d); }
    d.setAttribute("content", meta.desc);
    // §61 — Canonique : la page légale ne doit pas être dupliquée par les
    // paramètres de campagne qui traînent dans l'URL.
    let c = document.querySelector('link[rel="canonical"]');
    if (!c) { c = document.createElement("link"); c.setAttribute("rel", "canonical"); document.head.appendChild(c); }
    c.setAttribute("href", `https://vehicleiq.fr/${page}`);
  }, [page, meta.title, meta.desc]);

  // §45 — Sommaire sticky en desktop. Il est CONSTRUIT à partir du document
  // rendu plutôt que maintenu à la main : une CGU qui gagne un article ne doit
  // pas exiger une seconde modification ailleurs, sinon le sommaire ment.
  useEffect(() => {
    if (!bodyRef.current) return undefined;
    const build = () => {
      const heads = [...bodyRef.current.querySelectorAll("h2, h3")];
      const items = heads.map((h, i) => {
        if (!h.id) {
          h.id = `sec-${i}-${(h.textContent || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "")
            .replace(/[^A-Za-z0-9]+/g, "-").replace(/^-|-$/g, "").toLowerCase().slice(0, 40)}`;
        }
        return { id: h.id, text: (h.textContent || "").trim(), level: h.tagName === "H3" ? 3 : 2 };
      });
      setToc(items.filter(i => i.text));
    };
    build();
    // Le contenu légal peut arriver après le premier rendu (chargement
    // différé) : on reconstruit alors le sommaire au lieu d'afficher un vide.
    const mo = new MutationObserver(build);
    mo.observe(bodyRef.current, { childList: true, subtree: true });
    return () => mo.disconnect();
  }, [page, LegalContent]);

  useEffect(() => {
    if (!toc.length) return undefined;
    const io = new IntersectionObserver(
      entries => {
        const visible = entries.filter(e => e.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (visible[0]) setActiveId(visible[0].target.id);
      },
      { rootMargin: "-96px 0px -70% 0px", threshold: 0 }
    );
    toc.forEach(t => { const el = document.getElementById(t.id); if (el) io.observe(el); });
    return () => io.disconnect();
  }, [toc]);

  const go = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    const top = el.getBoundingClientRect().top + window.pageYOffset - 88;
    window.scrollTo({ top, behavior: "smooth" });
  };

  return (
    // §45 — Vraie page dans le shell public : navbar, hero léger, contenu à
    // largeur limitée, sommaire sticky, footer. Aucune popup, aucun bouton ✕ :
    // c'est un document consultable et imprimable, pas une boîte de dialogue.
    <main className="lv2-legal-page">
      <header className="lv2-legal-hero">
        <div className="lv2-wrap">
          <nav className="lv2-crumbs" aria-label="Fil d'Ariane">
            <button onClick={() => nav("/")}>Accueil</button><span>›</span><span>{meta.h1}</span>
          </nav>
          <h1 className="lv2-art-h1">{meta.h1}</h1>
          <p className="lv2-legal-meta">
            Version {displayVersion} · en vigueur depuis le{" "}
            {new Date(displayDate).toLocaleDateString("fr-FR", { day: "2-digit", month: "long", year: "numeric" })}
          </p>
        </div>
      </header>

      <div className="lv2-wrap lv2-legal-layout">
        {toc.length > 2 && (
          <aside className="lv2-legal-toc" aria-label="Sommaire">
            <div className="lv2-legal-toc-title">Sommaire</div>
            <ol>
              {toc.map(t => (
                <li key={t.id} className={`lvl-${t.level}${activeId === t.id ? " active" : ""}`}>
                  <button type="button" onClick={() => go(t.id)}>{t.text}</button>
                </li>
              ))}
            </ol>
          </aside>
        )}
        <article className="lv2-legal-body" ref={bodyRef}>
          {LegalContent ? <LegalContent type={meta.type} inline /> : <p className="lv2-lead">Contenu en cours de chargement.</p>}
        </article>
      </div>
    </main>
  );
}

export function AboutPage() {
  return (
    <main className="lv2-wrap lv2-section" style={{ paddingTop: "3rem", maxWidth: 760 }}>
      <div className="lv2-eyebrow">À propos</div>
      <h1 className="lv2-h2" style={{ fontSize: "clamp(2rem,4vw,2.8rem)" }}>VehicleIQ, l’assistant IA des dirigeants VO.</h1>
      <p className="lv2-lead">VehicleIQ est édité par MKL Ingénierie et Conseil, à Saint-Quentin. Nous construisons VIQ.AI pour les dirigeants du véhicule d’occasion : un assistant IA qui centralise les flux d’information, synchronise quatre moteurs IA et structure le workflow autour des objectifs, des prospects, du sourcing, des dossiers, de l’agenda et du pilotage de la performance.</p>
      <p className="lv2-lead">Conçu en France. Hébergé en Union européenne. Les données de nos clients ne servent pas à entraîner des modèles.</p>
    </main>
  );
}

/* v279 legacy pricing comparison tokens — non rendus :
Sourcing intelligent multi-marketplaces
Matching sourcing multi-critères
Liens sourcing
*/
